const Constantes = {
    URL_SERVIDOR: process.env.VUE_APP_RUTA_API,
};
export default Constantes;